import Header from '../header';
import {
  Container,
  FooterContainer,
  CancelButton,
  ConfirmButton,
} from '../styles';
import { TransitionDuration } from '../../../constants/styles-config';

const withModalContainer = (WrappedComponent) => (
  function WithModalContainer({
    isOpened,
    onClose,
    onSubmit,
    title,
    width = '718px',
    footer = true,
    cancelText = 'Cancel',
    submitText = 'OK',
    cancelWidth = '94px',
    submitWidth = '534px',
    contrastingFooter = false,
    cancelActionAvailable = true,
    ...props
  }) {
    const handleSubmit = () => {
      onSubmit();
      // onClose();
    };

    return (
      <Container
        isOpen={isOpened}
        overlayClassName="Overlay"
        shouldFocusAfterRender={false}
        closeTimeoutMS={TransitionDuration}
        width={width}
      >
        <Header
          title={title}
          onClose={onClose}
        />
        <WrappedComponent {...props} isLongerModal={!footer} />
        <FooterContainer footer={footer} contrasting={contrastingFooter} isLongerFooter={!footer}>
          {cancelActionAvailable && (
            <CancelButton
              cancelWidth={cancelWidth}
              onClick={onClose}
            >
              {cancelText}
            </CancelButton>
          )}

          {onSubmit ? (
            <ConfirmButton
              submitWidth={cancelActionAvailable ? submitWidth : '100%'}
              onClick={handleSubmit}
              aria-label={submitText}
            >
              <span>
                {submitText}
              </span>
            </ConfirmButton>
          ) : null}

        </FooterContainer>
      </Container>
    );
  }
);

export default withModalContainer;
